'use client';

import './globals.css';
import { useLanguage } from './contexts/LanguageContext';

export default function RootLayout({ children }) {
  const { isRTL } = useLanguage() || { isRTL: false };

  return (
    <html lang="en" dir={isRTL ? 'rtl' : 'ltr'} className="overflow-x-hidden">
      <head>
        <title>HUSSA - Trusted partner for big ideas</title>
        <meta name="description" content="Developing green spaces for the future" />
        <meta name="viewport" content="width=device-width, initial-scale=1" />

        {/* Favicon */}
        <link rel="icon" type="image/svg+xml" href="/favicon.svg" />

        {/* Open Graph */}
        <meta property="og:title" content="HUSSA - Partner for big ideas" />
        <meta property="og:description" content="Developing green spaces for the future" />
        <meta property="og:image" content="https://i.postimg.cc/1XqHzW8R/Logo-Mark.png" />
        <meta property="og:url" content="https://hussa.ba" />
        <meta property="og:type" content="website" />
        <meta property="og:site_name" content="HUSSA" />

        {/* Twitter Card */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="HUSSA - Partner for big ideas" />
        <meta name="twitter:description" content="Developing green spaces for the future" />
        <meta name="twitter:image" content="https://i.postimg.cc/1XqHzW8R/Logo-Mark.png" />

        {/* Font Awesome */}
        <link
          rel="stylesheet"
          href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/5.15.4/css/all.min.css"
        />

        {/* Custom Font */}
        <style jsx global>{`
          @font-face {
            font-family: 'Funnel Sans';
            src: url('/fonts/FunnelSans-Regular.woff2') format('woff2'),
                 url('/fonts/FunnelSans-Regular.woff') format('woff');
            font-weight: normal;
            font-style: normal;
          }

          * {
            font-family: 'Funnel Sans', sans-serif;
          }
        `}</style>
      </head>
      <body className="font-funnel overflow-x-hidden w-full relative">
        {children}
      </body>
    </html>
  );
}
